import { AppThunk } from '@/store'
import { createAction, request } from '@/store/actions'

import {
  ADD_AUDIT_CONNECTOR,
  CLEAR_AUDIT_CONNECTOR_SECRET,
  GET_AUDIT_CONNECTOR,
  REMOVE_AUDIT_CONNECTOR
} from './actionTypes'

export const getAuditConnectors = (): AppThunk => {
  return dispatch => {
    return dispatch(
      request('/organizations/:organizationId/apiconnectors?type=audit', GET_AUDIT_CONNECTOR, { method: 'GET' })
    )
  }
}

export const addAuditConnector = (): AppThunk => {
  return dispatch => {
    return dispatch(
      request('/organizations/:organizationId/apiconnectors', ADD_AUDIT_CONNECTOR, {
        method: 'POST',
        body: { type: 'audit' }
      })
    )
  }
}

export const deleteAuditConnector = (auditConnectorId: string): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId/apiconnectors/${auditConnectorId}`,
        REMOVE_AUDIT_CONNECTOR,
        { method: 'DELETE' },
        { args: { auditConnectorId } }
      )
    )
  }
}

export const clearClientSecret = (auditConnectorId: string): AppThunk => {
  return dispatch => {
    return new Promise(resolve => {
      resolve(dispatch(createAction(CLEAR_AUDIT_CONNECTOR_SECRET, { auditConnectorId })))
    })
  }
}
